
// If the first given number is negative, it makes the first one zero and offsets all other given numbers
export default function offset(...n) {
  return n[0] < 0 ? [...n].map(i => i + -n[0]) : n;
}



// WEBPACK FOOTER //
// ./website/vendor/scripts/fabrique/modules/number-offset.js